import { Link, useLocation } from 'react-router-dom'
import SeoHead from '@presentation/seo/SeoHead'

const QUICK_LINKS = [
  { to: '/', label: 'Home' },
  { to: '/news', label: 'News' },
  { to: '/webinars/latest', label: 'Latest Webinars' },
  { to: '/hacks', label: "Michel's PD Hacks" },
  { to: '/prof-bas-bloem-weekly', label: 'Prof Bas Bloem Weekly' },
]

export default function NotFoundPage() {
  const location = useLocation()

  return (
    <main className="bg-background py-10 sm:py-14">
      <SeoHead
        title="Page not found | Parkinson's Insights"
        description="The page you requested could not be found."
        canonicalPath={location.pathname || '/'}
        noindex
      />
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <div className="rounded-2xl border border-border-light bg-surface p-7 text-center shadow-sm sm:p-10">
          <p className="text-sm font-bold tracking-wide text-primary">404</p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-text-primary sm:text-4xl">
            Page not found
          </h1>
          <p className="mt-3 text-base text-text-secondary">
            The requested page does not exist or may have moved.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-2">
            {QUICK_LINKS.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="rounded-lg border border-blue px-4 py-2 text-sm font-semibold text-blue no-underline transition-colors hover:bg-blue/8"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </main>
  )
}
